import { IClickEventData } from 'types/analytics';

export const REWARD_VIEW_ANALYTICS: IClickEventData = {
    location: 'page',
    category: 'interaction',
    action: 'view all rewards'
};
